import React, { useCallback, useEffect, useState } from "react";
import { Button, Form, Nav, Modal } from "react-bootstrap";
import { FaDownload, FaFileCirclePlus, FaRegSquarePlus } from "react-icons/fa6";
import * as yup from "yup";
import { useFormik } from "formik";
import toast from "react-hot-toast";
import CustomisedModal from "../../components/Modal/CustomisedModal";
import sampleFile from "../../assets/files/sample-sheet.xlsx";
import sampleImageFile from "../../assets/files/images.zip";
import { Paper, Switch, Tooltip } from "@mui/material";
import DataTable from "react-data-table-component";
import Loader from "../../components/loader/loader";
import { checkUserPermissions } from "../../helpers/permission";
import { useNavigate } from "react-router";
import {
  deleteProduct,
  downloadProductsExcelSheet,
  getProductsListing,
  getProductsLowStockListing,
  getProductsOutStockListing,
  getProductsVariants,
  statusProductUpdate,
  uploadBulkProducts,
} from "../../api/context/products";
import Variant from "./Variant";
import { RiArrowDownSLine } from "react-icons/ri";
import { FaCloudUploadAlt } from "react-icons/fa";
import { Box } from "@material-ui/core";
import { getCategoryListingPaginate, getManufacturesListingPaginate, getStoresListing, getSubCategoryListingPaginate } from "../../api/context/manufacturer";
import { useRecoilState } from "recoil";
import { inventoryListFilter, inventoryPaginationState } from "../../atoms/inventoryListFIlter";
import AsyncSelect from 'react-select/async';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { getBrandListing } from "../../api/context/brand";
import { Spinner } from "reactstrap";
import { FiDownload, FiFilter, FiPackage, FiPlus, FiRefreshCw, FiTrash2, FiUploadCloud, FiX } from "react-icons/fi";
import { HiSparkles } from "react-icons/hi2";
import BulkUploadModal from "./helpers/bulkUploadModal";
import FilterModal from "./helpers/filterModal";

const queueDatatableCustomStyles = {
  header: {
    style: {
      fontWeight: '700',
      fontSize: '15px',
      color: '#0f172a',
      minHeight: '48px',
      padding: '8px 14px',
    },
  },
  headRow: {
    style: {
      backgroundColor: '#f8fafc',
      borderBottom: '1px solid #e2e8f0',
      minHeight: '48px',
    },
  },
  headCells: {
    style: {
      display: 'flex',
      justifyContent: 'center',
      fontWeight: '600',
      fontSize: '9px',
      padding: '10px 6px',
      color: '#475569',
      textTransform: 'uppercase',
      letterSpacing: '0.02em',
      backgroundColor: '#f8fafc',
    },
  },
  cells: {
    style: {
      display: 'flex',
      fontSize: '10px',
      fontWeight: '500',
      color: '#0f172a',
      padding: '10px 6px',
    },
  },
  rows: {
    style: {
      minHeight: '48px',
      borderBottom: '1px solid #eef2f7',
      transition: 'background 0.15s ease',
      '&:not(:last-of-type)': {
        borderBottom: '1px solid #eef2f7',
      },
      '&:hover': {
        backgroundColor: '#f8fafc !important',
        cursor: 'pointer',
      },
    },
  },
  pagination: {
    style: {
      borderTop: '1px solid #eef2f7',
      minHeight: '52px',
      fontSize: '12px',
      color: '#475569',
    },
  },
};

const Inventory = () => {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user"));
  const isAdmin = user?.userType === "ADMIN";

  // Recoil State Management
  const [filterData, setFilterData] = useRecoilState(inventoryListFilter);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [pagination, setPagination] = useRecoilState(inventoryPaginationState);

  // Local State
  const [showBulkModal, setShowBulkModal] = useState(false);
  const [show, setShow] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [totalExpandedRows, setTotalExpandedRows] = useState(0);
  const [totalActiveRows, setTotalActiveRows] = useState(0);
  const [totalInActiveRows, setTotalInActiveRows] = useState(0);
  const [update, setUpdate] = useState(false);
  const [updateoutstock, setUpdateOutStock] = useState(false);
  const [updatelowstock, setUpdateLowStock] = useState(false);
  const [activedata, setActiveData] = useState([]);
  const [inactivedata, setInActiveData] = useState([]);
  const [category, setCategory] = useState([]);
  const [subcategory, setSubCategory] = useState([]);
  const [data, setData] = useState([]);
  const [variantdata, setVariantData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [defaultLoading, setDefaultLoading] = useState(false);
  const [loadingnested, setLoadingNested] = useState(false);
  const [initial, setInitial] = useState(false);
  const [bulkLoading, setBulkLoading] = useState(false);
  const [expandedRows, setExpandedRows] = useState([]);
  const [store, setStore] = useState([]);
  const [modal, setModal] = useState(false);
  const [deletingId, setDeletingId] = useState("");
  const [showOff, setShowOff] = useState(false);
  const [brands, setBrands] = useState([]);
  const [manufacturers, setManufacturers] = useState([]);
  const [pagebrands, setPageBrands] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [pagemanufacture, setPageManufacture] = useState(1);
  const [hasMoreManufacture, setHasMoreManufacture] = useState(true);
  const [enableBulkInventory, setEnableBulkInventory] = useState(false);
  const [downloadInventoryExcel, setDownloadInventoryExcel] = useState(false);
  const [totalInventoryToDownload, setTotalInventoryToDownload] = useState([]);
  const [updatingStatusIds, setUpdatingStatusIds] = useState(new Set());

  // Derived state from Recoil
  const { page, limit, pageactive, limitactive, pageinactive, limitinactive } = pagination;
  const { filter, search } = filterData;

  const handleCloseOff = () => setShowOff(false);
  const handleShowOff = () => setShowOff(true);

  const stockViewOptions = [
    { value: "all", label: "All" },
    { value: "active", label: "Out of Stock" },
    { value: "inactive", label: "Low Stock" },
  ];

  const toggleModal = () => {
    setModal(!modal);
  };


  const handleShowBulkModal = () => {
    setShowBulkModal(true);
  };

  const handleShow = () => {
    setShow(true);
    setEnableBulkInventory(false);
  }

  const handleCloseBulkModal = () => {
    setShowBulkModal(false);
  };

  const handleBulkUploadSuccess = () => {
    setUpdate(!update);
  };

  // Columns Definition
  const columns = [
    {
      name: "Image",
      center: true,
      minWidth: "60px",
      grow: 1,
      cell: (row) => (
        <div
          style={{
            width: 34,
            height: 34,
            borderRadius: 4,
            overflow: 'hidden',
            background: '#f8fafc',
            border: '1px solid #e2e8f0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
          }}
        >
          {row?.thumbnailImageUrl ? (
            <img
              src={row.thumbnailImageUrl}
              alt={row?.productName || ''}
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              onError={(e) => { e.currentTarget.style.display = 'none'; }}
            />
          ) : (
            <span style={{ fontSize: 9, color: '#94a3b8' }}>—</span>
          )}
        </div>
      ),
    },
    {
      id: "productname",
      name: "Product Name",
      selector: (row) => row?.productName,
      cell: (row) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "5px",
            width: "100%",
            padding: "2px 4px",
            cursor: "pointer",
            fontSize: "10px",
            fontWeight: 500,
            color: "#0f172a",
          }}
          onClick={(e) => {
            e.stopPropagation();
            navigate("/edit-inventory/" + row.id);
          }}
        >
          {row?.isAiGenerated && (
            <Tooltip title="AI generated" disableInteractive placement="top">
              <span
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#008695",
                  flexShrink: 0,
                  fontSize: "10px",
                }}
              >
                <HiSparkles />
              </span>
            </Tooltip>
          )}

          <Tooltip title={row?.productName} disableInteractive placement="top">
            <span
              style={{
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                minWidth: 0,
                textAlign: "center",
              }}
            >
              {row?.productName}
            </span>
          </Tooltip>

          {Number(row?.notifyMeCount) > 0 && (
            <Tooltip
              title={`${Number(row?.notifyMeCount)} pending notify request${Number(row?.notifyMeCount) > 1 ? "s" : ""}`}
              arrow
              placement="top"
            >
              <span
                style={{
                  minWidth: "14px",
                  height: "14px",
                  borderRadius: "999px",
                  backgroundColor: "#fee2e2",
                  color: "#dc2626",
                  border: "1px solid #fecaca",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "8px",
                  fontWeight: 700,
                  padding: "0 3px",
                  lineHeight: 1,
                  flexShrink: 0,
                }}
              >
                {Number(row?.notifyMeCount)}
              </span>
            </Tooltip>
          )}
        </div>
      ),
      minWidth: "130px",
      grow: 1,
      center: true,
    },
    {
      id: "colors",
      name: "Color",
      selector: (row) => row?.color,
      cell: (row) => (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <div
            style={{
              width: "16px",
              height: "16px",
              border: "1px solid #e2e8f0",
              borderRadius: "50%",
              backgroundColor: row.color,
              boxShadow: 'inset 0 0 0 1px rgba(255,255,255,0.5)',
            }}
          />
        </div>
      ),
      minWidth: "55px",
      grow: 1,
      center: true,
    },
    ...(user?.userType === "ADMIN" ? [{
      id: 'storeName',
      name: 'Store',
      selector: (row) => row?.manufacturer?.storeName,
      cell: (row) => {
        const platform = row?.manufacturer?.externalPlatform?.toLowerCase();
        const platformData = {
          'woocommerce': { initial: 'W', color: '#96588a' },
          'shopify': { initial: 'S', color: '#5e8e3e' },
          'magento': { initial: 'M', color: '#f46f25' },
        };
        const platformInfo = platformData[platform];

        return (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
              cursor: 'pointer',
              padding: '2px 4px',
              gap: '5px',
              minWidth: 0,
              color: '#0f172a',
              fontSize: '10px',
              fontWeight: 500,
            }}
            onClick={(e) => { e.stopPropagation(); navigate('/edit-vendors/' + row?.manufacturer?.id); }}
          >
            {platformInfo && (
              <div
                style={{
                  flexShrink: 0,
                  width: '14px',
                  height: '14px',
                  borderRadius: '4px',
                  color: platformInfo.color,
                  background: `${platformInfo.color}15`,
                  border: `1px solid ${platformInfo.color}40`,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '8px',
                  fontWeight: 700,
                }}
              >
                {platformInfo.initial}
              </div>
            )}
            <Tooltip title={row?.manufacturer?.storeName} disableInteractive placement="top">
              <div
                style={{
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  minWidth: 0,
                  textDecoration: 'underline',
                  textUnderlineOffset: '2px',
                  textDecorationThickness: '1px',
                  textDecorationColor: '#94a3b8',
                }}
              >
                {row?.manufacturer?.storeName}
              </div>
            </Tooltip>
          </div>
        );
      },
      sortable: true,
      minWidth: '120px',
      grow: 1,
      center: true,
    }] : []),
    {
      id: "category",
      name: "Category",
      selector: (row) => row?.productSubcategory?.title,
      cell: (row) => {
        const category = row?.productSubcategory?.title?.toLowerCase();
        let bg = '#64748b';

        if (category?.includes('women') || category?.includes('woman')) bg = '#ec4899';
        else if (category?.includes('men')) bg = '#3b82f6';
        else if (category?.includes('kid')) bg = '#10b981';

        return (
          <div style={{ textAlign: 'center' }}>
            {row?.productSubcategory?.title ? (
              <Tooltip title={row?.productSubcategory?.title} disableInteractive placement="top">
                <span
                  style={{
                    backgroundColor: bg,
                    color: '#fff',
                    padding: '3px 8px',
                    borderRadius: '4px',
                    fontWeight: 600,
                    fontSize: '9px',
                    display: 'inline-block',
                    maxWidth: '100%',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    letterSpacing: '0.02em',
                  }}
                >
                  {row.productSubcategory.title}
                </span>
              </Tooltip>
            ) : (
              <span style={{ color: '#94a3b8', fontSize: '9px' }}>N/A</span>
            )}
          </div>
        );
      },
      minWidth: "90px",
      grow: 1,
      center: true,
    },
    {
      id: "price",
      name: "Price",
      selector: (row) => row?.price,
      cell: (row) => (
        <div style={{ textAlign: 'center', fontSize: '10px', fontWeight: 500, color: '#94a3b8', textDecoration: row?.discountedPrice != null && row?.discountedPrice !== '' && Number(row?.discountedPrice) < Number(row?.price) ? 'line-through' : 'none' }}>
          {row?.price != null && row?.price !== '' ? `₹${row.price}` : '-'}
        </div>
      ),
      minWidth: "70px",
      grow: 1,
      center: true,
    },
    {
      id: "discount",
      name: "Discounted",
      selector: (row) => row?.discountedPrice,
      cell: (row) => (
        <div style={{ textAlign: 'center', fontSize: '10px', fontWeight: 700, color: '#0f172a' }}>
          {row?.discountedPrice != null && row?.discountedPrice !== '' ? `₹${row.discountedPrice}` : '-'}
        </div>
      ),
      minWidth: "80px",
      grow: 1,
      center: true,
    },
    {
      id: "stock",
      name: "Stock",
      selector: (row) => row?.stock,
      cell: (row) => {
        const stock = Number(row?.stock || 0);
        let color = '#0f172a';
        if (stock <= 0) color = '#dc2626';
        else if (stock < 10) color = '#d97706';
        return (
          <span style={{ fontSize: '10px', fontWeight: 600, color }}>
            {stock}
          </span>
        );
      },
      minWidth: "60px",
      grow: 1,
      center: true,
    },
    {
      id: "action",
      name: "Actions",
      cell: (row, index) => (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          {checkUserPermissions("manage_products") ? (
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }} role="button" onClick={(e) => e.stopPropagation()}>
              {row?.isAiGenerated === true && row?.isPublished === false ? (
                <Tooltip title="Publish this draft first to enable" disableInteractive placement="top">
                  <span>
                    <Switch
                      size="small"
                      id={`custom-switch-${index}`}
                      checked={row?.isActive}
                      disabled
                    />
                  </span>
                </Tooltip>
              ) : (
                <Switch
                  size="small"
                  id={`custom-switch-${index}`}
                  checked={row?.isActive}
                  disabled={updatingStatusIds.has(row?.id)}
                  onChange={() => statusActive(row?.id)}
                />
              )}

              <Tooltip title="Delete" disableInteractive placement="top">
                <button
                  type="button"
                  onClick={(e) => { e.stopPropagation(); handleConfirm(row?.id); }}
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '24px',
                    height: '24px',
                    borderRadius: '6px',
                    border: '1px solid #fecaca',
                    background: '#fef2f2',
                    color: '#dc2626',
                    cursor: 'pointer',
                    padding: 0,
                    transition: 'all 0.15s ease',
                  }}
                  onMouseEnter={(e) => { e.currentTarget.style.background = '#fee2e2'; }}
                  onMouseLeave={(e) => { e.currentTarget.style.background = '#fef2f2'; }}
                >
                  <FiTrash2 size={12} />
                </button>
              </Tooltip>
            </div>
          ) : (
            <></>
          )}
        </div>
      ),
      center: true,
      minWidth: "90px",
      grow: 1,
    },
  ];

  const conditionalRowStyles = [
    {
      when: row => row.stock <= 0,
      style: {
        backgroundColor: 'rgba(220, 38, 38, 0.04)',
        '&:hover': {
          backgroundColor: 'rgba(220, 38, 38, 0.07) !important',
        },
      },
    },
  ];

  // Search Formik with Recoil Integration
  const searchFormik = useFormik({
    initialValues: {
      category: filterData.category || [],
      subCategory: filterData.subCategory || [],
      subSubCategory: filterData.subSubCategory || [],
      vendors: isAdmin ? (filterData.vendors || []) : [],
      brands: isAdmin ? (filterData.brands || []) : [],
      search: filterData.search || "",
      filter: filterData.filter || "all",
      minPrice: filterData.minPrice || 0,
      maxPrice: filterData.maxPrice || 99999
    },
    onSubmit: (values) => {

      setFilterData(prev => ({
        ...prev,
        category: values.category,
        subCategory: values.subCategory,
        subSubCategory: values.subSubCategory,
        vendors: values.vendors,
        brands: values.brands,
        search: values.search,
        filter: values.filter,
        minPrice: values.minPrice,
        maxPrice: values.maxPrice
      }));
    },
  });

  // Update Recoil state when form values change
  useEffect(() => {
    setFilterData(prev => ({
      ...prev,
      ...searchFormik.values
    }));
  }, [searchFormik.values, setFilterData]);

  // API Calls with Recoil State
  const fetchProductsData = async () => {
    const params = {
      page: pagination.page,
      limit: pagination.limit,
      search: filterData.search || '',
      category: null,
      subCategory: filterData.category || [],
      subSubCategory: filterData.subCategory || [],
      vendors: filterData.vendors || [],
      brands: filterData.brands || [],
      stock: filterData.stock || [],
      minPrice: filterData.minPrice || 0,
      maxPrice: filterData.maxPrice || 99999
    };

    getProductsListing(params)((response) => {
      if (response?.statusCode === 200) {
        setData(response?.data?.products);
        setTotalRows(response?.data?.totalItems);
        setDefaultLoading(false);
      } else {
        setData([]);
        setDefaultLoading(false);
      }
    });
  };

  const handleConfirm = (deletingId) => {
    setModal(!modal);
    setDeletingId(deletingId);
  };

  const deleteProducts = (id) => {
    setLoading(true)
    deleteProduct(id)((response) => {
      if (response?.data?.statusCode == 200) {
        setUpdate(!update);
        setModal(!modal);
        setLoading(false);
        toast.success("Product deleted successfully")
      } else {
        setLoading(false);
        toast.error(response?.data?.message);
      }
    });
  };

  const statusActive = (id) => {
    setUpdatingStatusIds((prev) => {
      const next = new Set(prev);
      next.add(id);
      return next;
    });
    statusProductUpdate(id)((response) => {
      setUpdatingStatusIds((prev) => {
        const next = new Set(prev);
        next.delete(id);
        return next;
      });
      if (response?.data?.statusCode == 200) {
        setData((prev) =>
          prev.map((product) =>
            product.id === id
              ? { ...product, isActive: !product.isActive }
              : product
          )
        );
        setVariantData((prev) =>
          prev.map((v) =>
            v.id === id ? { ...v, isActive: !v.isActive } : v
          )
        );
      } else {
        toast.error(response?.data?.message || "Failed to update status");
      }
    });
  };


  // Pagination Handlers with Recoil
  const handlePerRowsChange = (newPerPage, page) => {
    setPagination(prev => ({
      ...prev,
      limit: newPerPage,
      page: 1
    }));
    setUpdate(!update);
  };

  const handlePerRowsActiveChange = (newPerPage, page) => {
    setPagination(prev => ({
      ...prev,
      limitactive: newPerPage,
      pageactive: 1
    }));
    setUpdateOutStock(!updateoutstock);
  };

  const handlePerRowsInactiveChange = (newPerPage, page) => {
    setPagination(prev => ({
      ...prev,
      limitinactive: newPerPage,
      pageinactive: 1
    }));
    setUpdateLowStock(!updatelowstock);
  };

  const handlePageChange = (page) => {
    setPagination(prev => ({
      ...prev,
      page
    }));
    setUpdate(!update);
  };

  const handlePageActiveChange = (page) => {
    setPagination(prev => ({
      ...prev,
      pageactive: page
    }));
    setUpdateOutStock(!updateoutstock);
  };

  const handlePageInactiveChange = (page) => {
    setPagination(prev => ({
      ...prev,
      pageinactive: page
    }));
    setUpdateLowStock(!updatelowstock);
  };

  // Search Handler with Recoil
  const handleSearchChange = (value) => {
    setFilterData(prev => ({
      ...prev,
      search: value
    }));
  };

  // Filter Handlers with Recoil
  const applyFilters = (partial) => {
    const processedPartial = {};

    Object.keys(partial).forEach(key => {
      if (Array.isArray(partial[key])) {
        processedPartial[key] = partial[key].map(item => {
          if (typeof item === 'object' && item !== null) {
            return item.id || item.value;
          }
          return item;
        }).filter(id => id !== undefined);
      } else {
        processedPartial[key] = partial[key];
      }
    });

    const next = { ...searchFormik.values, ...processedPartial };
    searchFormik.setValues(next);
    setFilterData(prev => ({ ...prev, ...processedPartial }));
    setPagination(prev => ({ ...prev, page: 1 }));
  };

  const onBrandChange = (selectedOptions) => {
    const selectedValues = selectedOptions ? selectedOptions.map(option => option.value) : [];
    applyFilters({
      brands: selectedValues
    });
  };

  const onManufactureChange = (selectedOptions) => {
    const selectedValues = selectedOptions ? selectedOptions.map(option => option.value) : [];
    applyFilters({
      vendors: selectedValues
    });
  };

  const onCategoryChange = (selectedOption) => {
    applyFilters({
      category: selectedOption ? [selectedOption.value] : []
    });
  };

  const onSubCategoryChange = (selectedOptions) => {
    applyFilters({
      subCategory: selectedOptions && selectedOptions.length > 0
        ? selectedOptions.map(option => option.value)
        : []
    });
  };
  const handleStockViewChange = (opt) => {
    const nextFilter = opt?.value ?? "all";
    setFilterData(prev => ({
      ...prev,
      filter: nextFilter
    }));

    // Reset appropriate pagination
    setPagination(prev => ({
      ...prev,
      ...(nextFilter === "all" && { page: 1 }),
      ...(nextFilter === "active" && { pageactive: 1 }),
      ...(nextFilter === "inactive" && { pageinactive: 1 })
    }));

    // Trigger appropriate update
    if (nextFilter === "all") {
      setUpdate(u => !u);
    } else if (nextFilter === "active") {
      setUpdateOutStock(u => !u);
    } else {
      setUpdateLowStock(u => !u);
    }
  };

  const handleReset = () => {
    const resetValues = {
      category: [],
      subCategory: [],
      subSubCategory: [],
      vendors: [],
      brands: [],
      stock: [],
      search: "",
      filter: "all",
      minPrice: 0,
      maxPrice: 99999
    };

    searchFormik.resetForm({ values: resetValues });
    setFilterData(resetValues);
    setPagination({
      page: 1,
      limit: 10,
      pageactive: 1,
      limitactive: 10,
      pageinactive: 1,
      limitinactive: 10
    });
    setUpdate(!update);
  };

  // Async Select Loaders
  let typingTimer;

  const loadOptionsCategory = inputValue => {
    return new Promise((resolve, reject) => {
      clearTimeout(typingTimer);
      typingTimer = setTimeout(() => {
        if (true) {
          getCategoryListingPaginate({ page: 1, limit: 10, search: inputValue })(response => {
            if (response?.statusCode == 200) {
              resolve(response?.results);
              setCategory(response?.results)
            } else {
              resolve([]);
            }
          })
        }
        else {
          // resolve([]);
          // setCategory([])
          // setSubCategory([])
        }
      }, 300);
    });
  };

  const loadOptionsSubCategory = inputValue => {
    return new Promise((resolve, reject) => {
      clearTimeout(typingTimer);
      typingTimer = setTimeout(() => {
        const categoryId = searchFormik?.values?.selectedCategory?.value;
        if (categoryId) {
          getSubCategoryListingPaginate({ page: 1, pageSize: 10, search: inputValue, categoryIds: [categoryId] })(response => {
            if (response?.statusCode == 200) {
              resolve(response?.results);
              setSubCategory(response?.results)
            } else {
              resolve([]);
            }
          })
        }
        else {
          resolve([]);
          setSubCategory([])
        }
      }, 300);
    });
  };

  const fetchBrands = (inputValue, currentPage = 1, limit = 10) => {
    return new Promise((resolve) => {
      clearTimeout(typingTimer);
      typingTimer = setTimeout(() => {
        getBrandListing({ pagebrands: currentPage, pageSize: limit, search: inputValue })(response => {
          if (response?.statusCode === 200) {
            const results = response?.data?.map(item => ({
              value: item.id,
              label: item.name,
            }));

            if (currentPage === 1) {
              setBrands(results);
            } else {
              setBrands((prevBrands) => [...prevBrands, ...results]);
            }

            setHasMore(results.length > 0);
            resolve(results);
          } else {
            setHasMore(false);
            resolve([]);
          }
        });
      }, 300);
    });
  };

  const loadOptionsBrands = (inputValue) => {
    return fetchBrands(inputValue, 1);
  };

  const handleMenuScrollToBottom = () => {
    if (hasMore) {
      const nextPage = pagebrands + 1;
      fetchBrands(searchFormik.values.selected_brands?.label || '', nextPage).then(() => {
        setPageBrands(nextPage);
      });
    }
  };

  const fetchManufacturers = (inputValue, currentPage = 1, limit = 10) => {
    return new Promise((resolve) => {
      clearTimeout(typingTimer);
      typingTimer = setTimeout(() => {
        getManufacturesListingPaginate({ page: currentPage, limit, search: inputValue })(response => {
          if (response?.statusCode === 200) {
            const results = response?.results?.map(item => ({
              value: item.id,
              label: item.storeName,
            }));

            if (currentPage === 1) {
              setManufacturers(results);
            } else {
              setManufacturers((prevManufacturers) => [...prevManufacturers, ...results]);
            }

            setHasMoreManufacture(results.length > 0);
            resolve(results);
          } else {
            setHasMoreManufacture(false);
            resolve([]);
          }
        });
      }, 300);
    });
  };

  const loadOptionsManufacture = (inputValue) => {
    return fetchManufacturers(inputValue, 1);
  };

  const handleMenuScrollToBottomManufacture = () => {
    if (hasMoreManufacture) {
      const nextPage = pagemanufacture + 1;
      fetchManufacturers('', nextPage).then(() => {
        setPageManufacture(nextPage);
      });
    }
  };

  const loadStockOptions = (input) =>
    Promise.resolve(
      stockViewOptions.filter(o =>
        o.label.toLowerCase().includes((input || "").toLowerCase())
      )
    );

  const handleRowExpand = (row) => {
    setLoadingNested(true);
    const isRowExpanded = expandedRows.includes(row);
    setExpandedRows(
      [] && isRowExpanded ? expandedRows.filter((r) => r !== row) : [row]
    );
    getProductsVariants({
      productId: row.id,
      page: 1,
      pageSize: 10,
    })((response) => {
      if (response?.statusCode === 200) {
        setVariantData(response?.data?.products);
        setTotalExpandedRows(response?.data?.totalItems);
        setLoadingNested(false);
      } else {
        setVariantData([]);
        setLoadingNested(false);
      }
    });
  };

  const customNoOptionsMessage = ({ inputValue }) => {
    return <div>No options</div>;
  };

  const ExpandedComponent = useCallback(() => {
    return (
      <pre>
        <Variant
          variantdata={variantdata}
          loadingnested={loadingnested}
          statusActive={statusActive}
          handleConfirm={handleConfirm}
          handleRowExpand={handleRowExpand}
          checkUserPermissions={checkUserPermissions}
          totalExpandedRows={totalExpandedRows}
          limitvariant={10}
          pagevariant={1}
          handlePerRowsVariantChange={() => { }}
          handlePageVariantChange={() => { }}
        />
      </pre>
    );
  }, [variantdata, loadingnested]);

  // Effects
  useEffect(() => {
    if (searchFormik?.values?.subCategory) {
      getSubCategoryListingPaginate({ page: 1, limit: 10, search: '', categoryIds: searchFormik?.values?.subCategory })(response => {
        if (response?.statusCode == 200) {
          setSubCategory(response?.results)
        } else {
          setSubCategory([])
        }
      })
    }
  }, [searchFormik?.values?.subCategory]);

  useEffect(() => {
    getCategoryListingPaginate({ page: 1, limit: 10, search: '' })(response => {
      if (response?.statusCode == 200) {
        setCategory(response?.results)
      } else {
        setCategory([])
      }
    })

    getManufacturesListingPaginate({ page: 1, limit: 10, search: '' })(response => {
      if (response?.statusCode == 200) {
        setManufacturers(response?.results)
      }
    })

    getBrandListing({ page: 1, pageSize: 10, search: '' })(response => {
      if (response?.statusCode == 200) {
        setBrands(response?.data?.map((item, index) => {
          return {
            value: item.id,
            label: item.name
          }
        }))
      }
    })
  }, []);

  useEffect(() => {
    setDefaultLoading(true);
    fetchProductsData();
  }, [update, filterData]);

  useEffect(() => {
    let timeout = setTimeout(() => {
      if (initial) {
        if (filter === "all") {
          setUpdate(!update);
        } else if (filter === "active") {
          setUpdateOutStock(!updateoutstock);
        } else if (filter === "inactive") {
          setUpdateLowStock(!updatelowstock);
        }
      } else {
        setInitial(!initial);
      }
    }, 500);

    return () => {
      clearTimeout(timeout);
    };
  }, [filterData.search]);

  const getAppliedFiltersCount = () => {
    const formikValues = searchFormik?.values || {};
    let count = 0;

    const countIds = (array) => {
      if (!Array.isArray(array)) return 0;
      return array.filter(item => item !== undefined && item !== null).length;
    };

    if (isAdmin) {
      count += countIds(formikValues.brands);
      count += countIds(formikValues.vendors);
    }
    count += countIds(formikValues.category);
    count += countIds(formikValues.subCategory);
    count += countIds(formikValues.subSubCategory);
    count += countIds(formikValues.stock);

    // Count price range as 1 if min or max is different from defaults
    if ((formikValues.minPrice !== undefined && formikValues.minPrice !== 0) ||
      (formikValues.maxPrice !== undefined && formikValues.maxPrice !== 99999)) {
      count += 1;
    }

    return count;
  };

  const appliedFiltersCount = getAppliedFiltersCount();

  const exportInventoryToExcel = async () => {
    setDownloadInventoryExcel(true);

    try {
      // Build params EXACTLY matching fetchProductsData structure
      const params = {
        search: filterData.search || '',
        category: null, // Exactly as in fetchProductsData
        subCategory: filterData.category || [], // Exactly as in fetchProductsData
        subSubCategory: filterData.subCategory || [], // Exactly as in fetchProductsData
        vendors: isAdmin ? (filterData.vendors || []) : [],
        brands: isAdmin ? (filterData.brands || []) : [],
        minPrice: 0,
        maxPrice: 99999,
        // Add filter view param if needed
        filter: filter, // "all", "active", or "inactive"
        // For export, we typically want all data (not paginated)
        page: 1,
        limit: 1000000, // Large number to get all data
        // Include pagination state if needed for consistency
        ...pagination
      };

      console.log('Export params (matched with fetchProductsData):', params);

      // Call backend export API - should accept same params as getProductsListing
      const response = await downloadProductsExcelSheet(params);

      // Handle different response formats
      if (response?.status === 200 || response?.statusCode === 200) {
        // Get the actual data and headers
        const responseData = response.data || response;

        // Create blob - handle both binary and regular data
        let blob;
        if (responseData instanceof Blob) {
          blob = responseData;
        } else {
          const contentType = response.headers?.['content-type'] ||
            response.headers?.['Content-Type'] ||
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
          blob = new Blob([responseData], { type: contentType });
        }

        // Create download URL
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;

        // Generate descriptive filename
        const dateStr = new Date().toISOString().split("T")[0];
        let fileName = `inventory_export_${filter}_${dateStr}`;

        // Add filter indicators to filename if active
        const filters = [];
        if (filterData.search) filters.push(`search-${filterData.search.substring(0, 10)}`);
        if (filterData.category?.length > 0) filters.push(`${filterData.category.length}-cats`);
        if (filterData.subCategory?.length > 0) filters.push(`${filterData.subCategory.length}-subcats`);
        if (filterData.brands?.length > 0) filters.push(`${filterData.brands.length}-brands`);
        if (filterData.vendors?.length > 0) filters.push(`${filterData.vendors.length}-vendors`);

        if (filters.length > 0) {
          fileName += `_${filters.join('_')}`;
        }

        fileName += '.xlsx';

        link.setAttribute("download", fileName);

        // Trigger download
        document.body.appendChild(link);
        link.click();
        link.remove();

        // Clean up URL object
        window.URL.revokeObjectURL(url);

        toast.success(`Inventory exported successfully! File: ${fileName}`);
      } else {
        toast.error(response?.data?.message || "Export failed");
      }
    } catch (error) {
      console.error("Error exporting inventory to Excel:", error);
      toast.error(error.message || "Failed to export inventory");
    } finally {
      setDownloadInventoryExcel(false);
    }
  };

  return (
    <>
      <div className="inventory-page">
        <style>{`
          /* Match homepage: soft neutral background + consistent 16px horizontal gutter */
          .inventory-page { background: #f9fafb; min-height: calc(100vh - 70px); }
          .main-content:has(.inventory-page) { background: #f9fafb; }
          .page-content:has(.inventory-page) { background: #f9fafb; }
          body:has(.inventory-page) .page-content {
            padding-left: 16px !important;
            padding-right: 16px !important;
          }
          body:has(.inventory-page) .container-fluid,
          body:has(.inventory-page) .container {
            padding-left: 0 !important;
            padding-right: 0 !important;
          }
          .inventory-page h3 { font-size: 18px !important; }
          .inventory-page h4 { font-size: 16px !important; }
          .inventory-page h5 { font-size: 14px !important; }
          .inventory-page h6 { font-size: 12px !important; }
          .inventory-page p { font-size: 12px; }
          .inventory-page .small,
          .inventory-page small { font-size: 11px !important; }
          .inventory-page .badge { font-size: 10px !important; padding: 3px 7px !important; }
          .inventory-page .btn { font-size: 12px; }

          /* Compact action buttons in the header */
          .inventory-page .inv-btn {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            gap: 6px;
            padding: 6px 22px !important;
            border-radius: 4px !important;
            font-size: 12px !important;
            font-weight: 500 !important;
            height: 34px;
            white-space: nowrap;
            transition: all 0.15s ease;
            border: 1px solid #e2e8f0;
            background: #fff;
            color: #475569;
            cursor: pointer;
          }
          .inventory-page .inv-btn:hover {
            border-color: #008695;
            color: #008695;
            background: rgba(0,134,149,0.06);
          }
          .inventory-page .inv-btn-primary {
            background: #008695 !important;
            border-color: #008695 !important;
            color: #fff !important;
          }
          .inventory-page .inv-btn-primary:hover {
            background: #006672 !important;
            border-color: #006672 !important;
            color: #fff !important;
          }
          .inventory-page .inv-btn-ai {
            background: linear-gradient(135deg, #6366f1 0%, #a855f7 50%, #ec4899 100%) !important;
            border: none !important;
            color: #fff !important;
            font-weight: 600 !important;
            box-shadow: 0 2px 8px rgba(168, 85, 247, 0.25);
          }
          .inventory-page .inv-btn-ai:hover {
            filter: brightness(1.05);
            color: #fff !important;
            transform: translateY(-1px);
          }
          .inventory-page .inv-btn svg { width: 14px; height: 14px; }
          .inventory-page .inv-btn .icon { font-size: 14px; }

          /* Search input */
          .inventory-page .inv-search-input {
            border: 1px solid #e2e8f0 !important;
            border-radius: 4px !important;
            padding: 6px 12px !important;
            font-size: 12px !important;
            height: 34px !important;
            background: #fff !important;
            color: #0f172a !important;
          }
          .inventory-page .inv-search-input:focus {
            border-color: #008695 !important;
            box-shadow: 0 0 0 3px rgba(0,134,149,0.15) !important;
            outline: none;
          }

          /* Filter count badge */
          .inventory-page .inv-filter-count {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            min-width: 16px;
            height: 16px;
            padding: 0 4px;
            font-size: 10px;
            font-weight: 700;
            color: #fff;
            background: #008695;
            border-radius: 999px;
          }

          /* Data table container */
          .inventory-page .products-and-options .MuiPaper-root { border: 1px solid #e2e8f0 !important; border-radius: 10px !important; overflow: hidden; }

          /* Delete-confirm modal */
          .inv-delete-modal { max-width: 380px; }
          .inv-delete-modal-content {
            border: none !important;
            border-radius: 14px !important;
            box-shadow: 0 20px 50px rgba(15, 23, 42, 0.18) !important;
            overflow: hidden !important;
          }
          @media (max-width: 480px) {
            .inv-delete-modal { max-width: none !important; width: calc(100vw - 24px) !important; margin: 0 auto !important; }
          }

          /* Reset margins for consistency */
          .inventory-page .row { margin-bottom: 0; }

          /* Zero out .page-content top padding so the header sits flush with the top of the content area */
          body:has(.inventory-page) .page-content,
          body:has(.inventory-page) #layout-wrapper.no-topbar .page-content,
          body:has(.inventory-page) #layout-wrapper .page-content {
            padding-top: 0 !important;
            padding-bottom: 24px !important;
            padding-left: 16px !important;
            padding-right: 16px !important;
          }

          /* Sticky header — bleeds edge-to-edge; horizontal padding matches .modern-panel-header */
          .inventory-page .page-header-sticky {
            padding: clamp(14px, 1.6vw, 24px) clamp(14px, 1.4vw, 20px) clamp(10px, 1.2vw, 18px) !important;
            margin: 0 -16px 16px !important;
            top: 0 !important;
            background: #f9fafb !important;
            border-bottom: 1px solid #eef2f7 !important;
            box-shadow: none !important;
          }
          @media (max-width: 991px) {
            .inventory-page .page-header-sticky {
              padding: 16px 16px 12px !important;
            }
          }
          @media (max-width: 767.98px) {
            .inventory-page .page-header-sticky {
              padding: 10px 16px 8px !important;
              margin: 0 -16px 8px !important;
              position: static !important;
            }
          }
          @media (max-width: 480px) {
            .inventory-page .page-header-sticky {
              padding: 10px 16px 8px !important;
              margin: 0 -16px 8px !important;
            }
          }

          /* Content sits inside the standard page-content padding (16px sides) */
          .inventory-page .inv-search-row { margin: 12px 0 !important; padding: 0; }
          @media (max-width: 767.98px) {
            .inventory-page .inv-search-row { margin: 0 0 8px !important; }
          }
          .inventory-page .products-and-options { padding: 0; }

          /* Mobile grid — hidden on desktop */
          .inventory-page .inventory-mobile-grid { display: none; }
          .inventory-page .inventory-mobile-pagination { display: none; }

          /* Reusable empty state (used by desktop DataTable + mobile grid) */
          .inventory-page .inv-empty {
            width: 100%;
            min-height: 340px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding: 32px 20px;
            text-align: center;
            color: #64748b;
            background: linear-gradient(180deg, #fafbfd 0%, #f5f7fa 100%);
          }
          .inventory-page .inv-empty-icon {
            font-size: 40px;
            margin-bottom: 12px;
            opacity: 0.7;
            filter: grayscale(0.2);
          }
          .inventory-page .inv-empty-title {
            font-size: 15px;
            font-weight: 700;
            color: #0f172a;
            letter-spacing: -0.01em;
            margin: 0 0 4px;
          }
          .inventory-page .inv-empty-sub {
            font-size: 12px;
            color: #94a3b8;
            font-weight: 500;
            margin: 0;
          }

          /* Responsive: mobile stack */
          @media (max-width: 767.98px) {
            /* Keep title + action buttons on the same row */
            .inventory-page .page-header-sticky > .d-flex {
              flex-wrap: nowrap !important;
              gap: 6px !important;
            }
            .inventory-page .page-header-sticky > .d-flex > h3 {
              min-width: 0;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .inventory-page .inv-header-actions {
              gap: 6px !important;
              flex-wrap: nowrap !important;
              flex-shrink: 0;
            }
            .inventory-page .inv-header-actions > * { flex-shrink: 0; }

            /* Header action buttons: icon-only on mobile */
            .inventory-page .inv-header-actions .inv-btn {
              width: 32px;
              height: 32px;
              padding: 0 !important;
              justify-content: center;
            }
            .inventory-page .inv-header-actions .inv-btn .inv-btn-label { display: none; }

            /* Search + filter + clear on one row */
            .inventory-page .inv-search-row { flex-wrap: nowrap !important; gap: 8px !important; }
            .inventory-page .inv-search-row > div:first-child { flex: 1 1 auto !important; min-width: 0 !important; }
            .inventory-page .inv-search-row .inv-filter-actions { flex-shrink: 0; gap: 6px !important; }

            /* Filter and Clear buttons: icon only */
            .inventory-page .inv-filter-btn,
            .inventory-page .inv-clear-btn {
              width: 34px;
              padding: 0 !important;
              justify-content: center;
            }
            .inventory-page .inv-filter-btn .inv-btn-label,
            .inventory-page .inv-clear-btn .inv-btn-label { display: none; }
            .inventory-page .inv-filter-btn .inv-filter-count {
              position: absolute;
              top: -4px; right: -4px;
              min-width: 14px; height: 14px;
              padding: 0 3px;
              font-size: 9px;
            }
            .inventory-page .inv-filter-btn { position: relative; }

            /* Hide DataTable, show mobile card grid */
            .inventory-page .products-and-options { display: none !important; }
            .inventory-page .inventory-mobile-grid {
              display: grid;
              grid-template-columns: repeat(2, minmax(0, 1fr));
              gap: 10px;
              padding: 8px 0 calc(60px + env(safe-area-inset-bottom, 0px));
            }

            /* Fixed bottom pagination bar */
            .inventory-page .inventory-mobile-pagination {
              display: flex !important;
              position: fixed;
              left: 0; right: 0; bottom: 0;
              padding: 8px 12px calc(8px + env(safe-area-inset-bottom, 0px));
              background: #fff;
              border-top: 1px solid #e2e8f0;
              box-shadow: 0 -2px 8px rgba(15,23,42,0.05);
              z-index: 1049;
              align-items: center;
              justify-content: space-between;
              gap: 10px;
            }
            .inventory-page .imp-btn {
              width: 40px; height: 36px;
              border-radius: 6px;
              border: 1px solid #e2e8f0;
              background: #fff;
              color: #0f172a;
              font-size: 16px;
              font-weight: 700;
              cursor: pointer;
              display: inline-flex; align-items: center; justify-content: center;
              transition: all 0.15s ease;
            }
            .inventory-page .imp-btn:hover:not(:disabled) {
              border-color: #008695;
              color: #008695;
              background: rgba(0,134,149,0.06);
            }
            .inventory-page .imp-btn:disabled { opacity: 0.35; cursor: not-allowed; }
            .inventory-page .imp-info {
              font-size: 11px;
              color: #475569;
              display: inline-flex;
              align-items: baseline;
              gap: 4px;
              flex: 1;
              justify-content: center;
              text-align: center;
            }
            .inventory-page .imp-info strong { color: #008695; font-weight: 700; }
            .inventory-page .imp-total { color: #94a3b8; font-size: 10px; }
            .inventory-page .inventory-mobile-card {
              background: #fff;
              border: 1px solid #e2e8f0;
              border-radius: 8px;
              overflow: hidden;
              cursor: pointer;
              display: flex;
              flex-direction: column;
              transition: transform 0.15s ease, box-shadow 0.2s ease, border-color 0.15s ease;
            }
            .inventory-page .inventory-mobile-card:active {
              transform: scale(0.98);
              border-color: #008695;
            }
            .inventory-page .mobile-card-media {
              position: relative;
              aspect-ratio: 3 / 4;
              background: #f8fafc;
              overflow: hidden;
            }
            .inventory-page .mobile-card-media img {
              width: 100%; height: 100%; object-fit: cover; display: block;
            }
            .inventory-page .mobile-card-noimg {
              width: 100%; height: 100%;
              display: flex; align-items: center; justify-content: center;
              color: #94a3b8; font-size: 11px;
            }
            .inventory-page .mobile-card-stock {
              position: absolute;
              top: 8px; right: 8px;
              font-size: 9px;
              font-weight: 700;
              padding: 3px 7px;
              border-radius: 4px;
              border: 1px solid;
              white-space: nowrap;
              backdrop-filter: blur(4px);
            }
            .inventory-page .mobile-card-ai {
              position: absolute;
              top: 8px; left: 8px;
              width: 22px; height: 22px;
              display: inline-flex; align-items: center; justify-content: center;
              background: rgba(255,255,255,0.95);
              color: #008695;
              border: 1px solid rgba(0,134,149,0.25);
              border-radius: 999px;
              font-size: 11px;
              box-shadow: 0 1px 4px rgba(15,23,42,0.15);
              backdrop-filter: blur(4px);
            }
            .inventory-page .mobile-card-toggle {
              display: inline-flex;
              flex-shrink: 0;
            }
            .inventory-page .mobile-card-toggle .MuiSwitch-root { transform: scale(0.75); margin: -8px; }
            .inventory-page .mobile-card-color {
              position: absolute;
              bottom: 8px; right: 8px;
              width: 20px; height: 20px;
              border-radius: 50%;
              border: 2px solid rgba(255,255,255,0.9);
              box-shadow: 0 1px 4px rgba(15,23,42,0.25);
            }
            .inventory-page .mobile-card-body {
              padding: 8px 10px 10px;
              display: flex;
              flex-direction: column;
              gap: 2px;
            }
            .inventory-page .mobile-card-name {
              font-size: 12px;
              font-weight: 600;
              color: #0f172a;
              line-height: 1.3;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            .inventory-page .mobile-card-store {
              font-size: 10px;
              color: #94a3b8;
              font-weight: 500;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            .inventory-page .mobile-card-price-row {
              display: flex;
              align-items: center;
              justify-content: space-between;
              gap: 8px;
              margin-top: 4px;
            }
            .inventory-page .mobile-card-prices {
              display: flex; align-items: baseline; gap: 6px;
              flex-wrap: wrap;
              min-width: 0;
            }
            .inventory-page .mobile-card-price-final {
              font-size: 13px;
              font-weight: 700;
              color: #008695;
            }
            .inventory-page .mobile-card-price-strike {
              font-size: 10px;
              color: #94a3b8;
              text-decoration: line-through;
            }
            .inventory-page .mobile-grid-empty {
              grid-column: 1 / -1;
              min-height: 380px;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              padding: 32px 20px;
              text-align: center;
              color: #64748b;
              background: linear-gradient(180deg, #fafbfd 0%, #f5f7fa 100%);
              border: 1px solid #eef2f7;
              border-radius: 12px;
            }
            .inventory-page .mobile-grid-empty .inv-empty-icon {
              font-size: 40px;
              margin-bottom: 12px;
              opacity: 0.7;
              filter: grayscale(0.2);
            }
            .inventory-page .mobile-grid-empty .inv-empty-title {
              font-size: 15px;
              font-weight: 700;
              color: #0f172a;
              letter-spacing: -0.01em;
              margin: 0 0 4px;
            }
            .inventory-page .mobile-grid-empty .inv-empty-sub {
              font-size: 12px;
              color: #94a3b8;
              font-weight: 500;
              margin: 0;
            }
          }
        `}</style>

        {/* Sticky Header */}
        <div className="page-header-sticky">
                <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                  <h3 style={{ fontSize: '18px', fontWeight: 700, color: '#111827', margin: 0, letterSpacing: '-0.01em' }}>Inventory</h3>

                  {/* Action Buttons */}
                  <div className="inv-header-actions d-flex align-items-center gap-2 flex-wrap">
                    <div
                      className="inv-btn"
                      onClick={() => exportInventoryToExcel()}
                      title="Export"
                    >
                      {downloadInventoryExcel ? (
                        <>
                          <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                          <span className="inv-btn-label">Exporting...</span>
                        </>
                      ) : (
                        <>
                          <FiDownload />
                          <span className="inv-btn-label">Export</span>
                        </>
                      )}
                    </div>

                    <button type="button" className="inv-btn" onClick={handleShowBulkModal} title="Bulk Upload">
                      <FiUploadCloud />
                      <span className="inv-btn-label">Bulk Upload</span>
                    </button>

                    {(user?.userType === "Vendor") && (
                      <button type="button" className="inv-btn" onClick={() => navigate("/sync-inventory")} title="Smart Inventory">
                        <FiRefreshCw />
                        <span className="inv-btn-label">Smart Inventory</span>
                      </button>
                    )}

                    {checkUserPermissions("manage_products") ? (
                      <button type="button" className="inv-btn inv-btn-ai" onClick={() => navigate("/create-ai-inventory")} title="AI Listing">
                        <HiSparkles style={{ filter: 'drop-shadow(0 0 4px rgba(255,255,255,0.6))' }} />
                        <span className="inv-btn-label">AI Listing</span>
                      </button>
                    ) : null}

                    {checkUserPermissions("manage_products") ? (
                      <button type="button" className="inv-btn inv-btn-primary" onClick={() => navigate("/create-inventory")} title="Add Product">
                        <FiPlus strokeWidth={2.5} />
                        <span className="inv-btn-label">Add Product</span>
                      </button>
                    ) : null}
                  </div>
                </div>

              </div>

              {/* Search + Filter row — outside sticky header */}
              <div className="inv-search-row d-flex justify-content-between align-items-center gap-2 flex-wrap">
                <div style={{ flex: 2, minWidth: '220px' }}>
                  <Form.Control
                    type="text"
                    className="inv-search-input"
                    placeholder="Search for products..."
                    value={filterData.search}
                    onChange={(e) => handleSearchChange(e.target.value)}
                  />
                </div>

                <div className="inv-filter-actions d-flex align-items-center gap-2">
                  <button type="button" className="inv-btn inv-filter-btn" onClick={() => setShowFilterModal(true)} aria-label="Filter">
                    <FiFilter />
                    <span className="inv-btn-label">Filter</span>
                    {appliedFiltersCount > 0 && (
                      <span className="inv-filter-count">{appliedFiltersCount}</span>
                    )}
                  </button>
                  <button type="button" className="inv-btn inv-clear-btn" onClick={handleReset} aria-label="Clear filters">
                    <FiX />
                    <span className="inv-btn-label">Clear</span>
                  </button>
                </div>
              </div>

              {/* <Offcanvas show={showOff} onHide={handleCloseOff} placement='end'>
                <Offcanvas.Header closeButton>
                  <Offcanvas.Title>Filters</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                  <div className="request_wrapper_filter">
                    <Form onSubmit={searchFormik.handleSubmit}>
                      <div className='seperation_filter_reports'>
                        <Form.Group className="mb-3">
                          <Form.Label className='mb-2'>Category</Form.Label>
                          <AsyncSelect
                            loadOptions={loadOptionsCategory}
                            defaultOptions={category}
                            classNamePrefix="select"
                            isClearable={true}
                            placeholder={'Search Categories'}
                            onChange={onCategoryChange}
                            value={searchFormik.values.selectedCategory}
                            noOptionsMessage={customNoOptionsMessage}
                            theme={(theme) => ({
                              ...theme,
                              borderRadius: "0 10px 10px 10px",
                              colors: {
                                ...theme.colors,
                                primary: '#779be1',
                              },
                            })}
                            styles={{
                              menu: (baseStyles) => ({
                                ...baseStyles,
                                zIndex: 9999,
                              }),
                              control: (provided) => ({
                                ...provided,
                                border: " 1px solid #a7a7a7",
                                padding: '6px',
                              }),
                            }}
                          />
                        </Form.Group>

                        <Form.Group className="mb-3">
                          <Form.Label className='mb-2'>Sub-Category</Form.Label>
                          <AsyncSelect
                            isMulti
                            loadOptions={loadOptionsSubCategory}
                            defaultOptions={true}
                            classNamePrefix="select"
                            isClearable={true}
                            placeholder={'Search Sub Categories'}
                            onChange={onSubCategoryChange}
                            value={searchFormik.values.selectedSubCategory}
                            isDisabled={searchFormik.values.selectedCategory === ''}
                            noOptionsMessage={customNoOptionsMessage}
                            theme={(theme) => ({
                              ...theme,
                              borderRadius: "0 10px 10px 10px",
                              colors: {
                                ...theme.colors,
                                primary: '#779be1',
                              },
                            })}
                            styles={{
                              menu: (baseStyles) => ({
                                ...baseStyles,
                                zIndex: 9999,
                              }),
                              control: (provided) => ({
                                ...provided,
                                border: " 1px solid #a7a7a7",
                                padding: '6px',
                              }),
                            }}
                          />
                        </Form.Group>

                        <Form.Group className="mb-3">
                          <Form.Label className='mb-2'>Brands</Form.Label>
                          <AsyncSelect
                            isMulti
                            loadOptions={loadOptionsBrands}
                            defaultOptions={brands}
                            classNamePrefix="select"
                            isClearable={true}
                            placeholder="Search Brands"
                            onChange={onBrandChange}
                            value={searchFormik.values.selected_brands}
                            onMenuScrollToBottom={handleMenuScrollToBottom}
                            noOptionsMessage={() => (hasMore ? "Loading more options..." : "No more options")}
                            theme={(theme) => ({
                              ...theme,
                              borderRadius: "0 10px 10px 10px",
                              colors: {
                                ...theme.colors,
                                primary: '#779be1',
                              },
                            })}
                            styles={{
                              menu: (baseStyles) => ({
                                ...baseStyles,
                                zIndex: 9999,
                              }),
                              control: (provided) => ({
                                ...provided,
                                border: "1px solid #a7a7a7",
                                padding: '6px',
                              }),
                            }}
                          />
                        </Form.Group>

                        <Form.Group className="mb-3">
                          <Form.Label className='mb-2'>Vendors</Form.Label>
                          <AsyncSelect
                            isMulti
                            loadOptions={loadOptionsManufacture}
                            defaultOptions={manufacturers}
                            classNamePrefix="select"
                            isClearable={true}
                            placeholder="Search Vendors"
                            onChange={onManufactureChange}
                            value={searchFormik.values.selected_vendors}
                            onMenuScrollToBottom={handleMenuScrollToBottomManufacture}
                            noOptionsMessage={() => (hasMoreManufacture ? "Loading more options..." : "No more options")}
                            theme={(theme) => ({
                              ...theme,
                              borderRadius: "0 10px 10px 10px",
                              colors: {
                                ...theme.colors,
                                primary: '#779be1',
                              },
                            })}
                            styles={{
                              menu: (baseStyles) => ({
                                ...baseStyles,
                                zIndex: 9999,
                              }),
                              control: (provided) => ({
                                ...provided,
                                border: "1px solid #a7a7a7",
                                padding: '6px',
                              }),
                            }}
                          />
                        </Form.Group>

                        <div className='btn-groups'>
                          <Button className='search_filter' type='submit'>Search</Button>
                          <Button className='reset_btn_wrapper' onClick={handleReset}>Reset</Button>
                        </div>
                      </div>
                    </Form>
                  </div>
                </Offcanvas.Body>
              </Offcanvas> */}



              {/* Filter Modal */}
              <FilterModal
                show={showFilterModal}
                onHide={() => setShowFilterModal(false)}
                filters={{}}
                onApplyFilters={() => {

                  searchFormik.handleSubmit();
                }}
                searchFormik={searchFormik}
                onCategoryChange={onCategoryChange}
                onSubCategoryChange={onSubCategoryChange}
                onBrandChange={onBrandChange}
                onManufactureChange={onManufactureChange}
                userType={user?.userType}
              />

          <Modal
            show={modal}
            onHide={() => !loading && setModal(false)}
            centered
            backdrop={loading ? 'static' : true}
            keyboard={!loading}
            dialogClassName="inv-delete-modal"
            contentClassName="inv-delete-modal-content"
          >
            <Modal.Body style={{ padding: '22px 22px 18px', textAlign: 'center' }}>
              <div
                style={{
                  width: 52,
                  height: 52,
                  borderRadius: '50%',
                  background: '#fef2f2',
                  border: '1px solid #fecaca',
                  color: '#dc2626',
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: 12,
                }}
              >
                <FiTrash2 size={22} />
              </div>
              <h5 style={{ fontSize: 16, fontWeight: 700, color: '#0f172a', margin: '0 0 6px', letterSpacing: '-0.01em' }}>
                Delete product?
              </h5>
              <p style={{ fontSize: 12.5, color: '#64748b', margin: 0, lineHeight: 1.5 }}>
                This action cannot be undone. The selected product will be permanently removed.
              </p>
            </Modal.Body>
            <Modal.Footer
              style={{
                padding: '12px 18px',
                borderTop: '1px solid #eef2f7',
                display: 'flex',
                gap: 8,
                justifyContent: 'stretch',
              }}
            >
              <button
                type="button"
                onClick={() => setModal(false)}
                disabled={loading}
                style={{
                  flex: 1,
                  height: 38,
                  borderRadius: 6,
                  border: '1px solid #e2e8f0',
                  background: '#fff',
                  color: '#0f172a',
                  fontSize: 12.5,
                  fontWeight: 600,
                  cursor: loading ? 'not-allowed' : 'pointer',
                  opacity: loading ? 0.6 : 1,
                  transition: 'all 0.15s ease',
                }}
              >
                No
              </button>
              <button
                type="button"
                onClick={() => deleteProducts(deletingId)}
                disabled={loading}
                style={{
                  flex: 1,
                  height: 38,
                  borderRadius: 6,
                  border: '1px solid #dc2626',
                  background: '#dc2626',
                  color: '#fff',
                  fontSize: 12.5,
                  fontWeight: 600,
                  cursor: loading ? 'not-allowed' : 'pointer',
                  opacity: loading ? 0.85 : 1,
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: 6,
                  boxShadow: '0 3px 8px rgba(220,38,38,0.22)',
                  transition: 'all 0.15s ease',
                }}
              >
                {loading ? (
                  <>
                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                    Deleting...
                  </>
                ) : (
                  <>
                    <FiTrash2 size={13} />
                    Yes, Delete
                  </>
                )}
              </button>
            </Modal.Footer>
          </Modal>

          {/* Mobile-only card grid — replaces the DataTable on small screens */}
          <div className="inventory-mobile-grid">
            {(loading || defaultLoading) ? (
              <div style={{ gridColumn: '1 / -1', minHeight: '40vh' }}><Loader /></div>
            ) : (() => {
              const mobileData = filter === 'active' ? activedata : filter === 'inactive' ? inactivedata : data;
              if (!mobileData || mobileData.length === 0) {
                return (
                  <div className="mobile-grid-empty">
                    <div className="inv-empty-icon" aria-hidden="true">📦</div>
                    <p className="inv-empty-title">No products found</p>
                    <p className="inv-empty-sub">Add products to see them listed here.</p>
                  </div>
                );
              }
              return mobileData.map((row) => {
                const stock = Number(row?.stock || 0);
                const stockColor = stock <= 0 ? '#dc2626' : stock < 10 ? '#d97706' : '#22c55e';
                const stockBg = stock <= 0 ? '#fee2e2' : stock < 10 ? '#fef3c7' : '#dcfce7';
                const price = isAdmin ? row?.amount : row?.billingAmount;
                const hasDiscount = row?.discountedPrice != null && row?.discountedPrice !== '' && Number(row?.discountedPrice) < Number(row?.price);
                return (
                  <div
                    key={row?.id}
                    className="inventory-mobile-card"
                    onClick={() => navigate('/edit-inventory/' + row.id)}
                    role="button"
                  >
                    <div className="mobile-card-media">
                      {row?.thumbnailImageUrl ? (
                        <img
                          src={row.thumbnailImageUrl}
                          alt={row?.productName || ''}
                          onError={(e) => { e.currentTarget.style.display = 'none'; }}
                        />
                      ) : (
                        <div className="mobile-card-noimg">No image</div>
                      )}
                      {row?.isAiGenerated && (
                        <span className="mobile-card-ai" title="AI generated">
                          <HiSparkles />
                        </span>
                      )}
                      <span className="mobile-card-stock" style={{ color: stockColor, background: stockBg, borderColor: stockColor + '55' }}>
                        {stock <= 0 ? 'Out of stock' : `${stock} in stock`}
                      </span>
                      {row?.color && (
                        <span
                          className="mobile-card-color"
                          style={{ backgroundColor: row.color }}
                          title={`Color: ${row.color}`}
                        />
                      )}
                    </div>
                    <div className="mobile-card-body">
                      <div className="mobile-card-name" title={row?.productName}>{row?.productName || 'Untitled'}</div>
                      {isAdmin && row?.manufacturer?.storeName && (
                        <div className="mobile-card-store" title={row.manufacturer.storeName}>
                          {row.manufacturer.storeName}
                        </div>
                      )}
                      <div className="mobile-card-price-row">
                        <div className="mobile-card-prices">
                          {hasDiscount ? (
                            <>
                              <span className="mobile-card-price-final">₹{row?.discountedPrice}</span>
                              <span className="mobile-card-price-strike">₹{row?.price}</span>
                            </>
                          ) : (
                            <span className="mobile-card-price-final">₹{price ?? row?.price ?? '-'}</span>
                          )}
                        </div>
                        {checkUserPermissions('manage_products') && (
                          <span
                            className="mobile-card-toggle"
                            onClick={(e) => e.stopPropagation()}
                          >
                            {row?.isAiGenerated === true && row?.isPublished === false ? (
                              <Tooltip title="Publish this draft first to enable" disableInteractive placement="top">
                                <span>
                                  <Switch
                                    size="small"
                                    checked={!!row?.isActive}
                                    disabled
                                  />
                                </span>
                              </Tooltip>
                            ) : (
                              <Switch
                                size="small"
                                checked={!!row?.isActive}
                                disabled={updatingStatusIds.has(row?.id)}
                                onChange={() => statusActive(row?.id)}
                              />
                            )}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                );
              });
            })()}
          </div>

          {/* Mobile-only fixed pagination bar */}
          {(() => {
            const currentPage = filter === 'active' ? pageactive : filter === 'inactive' ? pageinactive : page;
            const currentLimit = filter === 'active' ? limitactive : filter === 'inactive' ? limitinactive : limit;
            const currentTotal = filter === 'active' ? totalActiveRows : filter === 'inactive' ? totalInActiveRows : totalRows;
            const totalPages = Math.max(1, Math.ceil((currentTotal || 0) / (currentLimit || 1)));
            const canPrev = currentPage > 1;
            const canNext = currentPage < totalPages;
            return (
              <div className="inventory-mobile-pagination">
                <button
                  type="button"
                  className="imp-btn"
                  onClick={() => canPrev && handlePageChange(currentPage - 1)}
                  disabled={!canPrev}
                  aria-label="Previous page"
                >
                  ←
                </button>
                <span className="imp-info">
                  Page <strong>{currentPage}</strong> of <strong>{totalPages}</strong>
                  <span className="imp-total">· {currentTotal || 0}</span>
                </span>
                <button
                  type="button"
                  className="imp-btn"
                  onClick={() => canNext && handlePageChange(currentPage + 1)}
                  disabled={!canNext}
                  aria-label="Next page"
                >
                  →
                </button>
              </div>
            );
          })()}

          {filter == "all" && (
            <Box className="products-and-options" sx={{ mt: 1 }}>
              <Paper square className='shadow-none border border-blue-grey-200'>
                <div>
                  <DataTable
                    columns={columns}
                    data={data}
                    progressPending={loading || defaultLoading}
                    conditionalRowStyles={conditionalRowStyles}
                    pointerOnHover
                    highlightOnHover
                    paginationRowsPerPageOptions={[10, 50, 100, 150]}
                    progressComponent={
                      <div style={{ height: "60vh" }}>
                        <Loader />
                      </div>
                    }
                    pagination
                    paginationServer
                    paginationTotalRows={totalRows}
                    paginationPerPage={limit}
                    onChangeRowsPerPage={handlePerRowsChange}
                    onChangePage={handlePageChange}
                    currentPage={page}
                    paginationDefaultPage={page}
                    customStyles={queueDatatableCustomStyles}
                    expandableRows
                    expandOnRowClicked={false}
                    onRowExpandToggled={handleRowExpand}
                    expandableRowsComponent={ExpandedComponent}
                    expandableRowsHideExpander
                    onRowClicked={(row) => navigate("/edit-inventory/" + row.id)}
                    expandableRowExpanded={(row) => expandedRows.includes(row)}
                    noDataComponent={
                      <div className="inv-empty">
                        <div className="inv-empty-icon" aria-hidden="true">📦</div>
                        <p className="inv-empty-title">No products found</p>
                        <p className="inv-empty-sub">Add products to see them listed here.</p>
                      </div>
                    }
                  />
                </div>
              </Paper>
            </Box>
          )}

          {filter == "active" && (
            <Box className="products-and-options" sx={{ mt: 1 }}>
              <Paper square className='shadow-none border border-blue-grey-200'>
                <div>
                  <DataTable
                    columns={columns}
                    data={activedata}
                    progressPending={loading || defaultLoading}
                    progressComponent={
                      <div style={{ height: "60vh" }}>
                        <Loader />
                      </div>
                    }
                    pagination
                    paginationServer
                    pointerOnHover
                    highlightOnHover
                    paginationTotalRows={totalActiveRows}
                    paginationPerPage={limitactive}
                    paginationRowsPerPageOptions={[10, 50, 100, 150]}
                    onChangeRowsPerPage={handlePerRowsActiveChange}
                    onChangePage={handlePageActiveChange}
                    currentPage={pageactive}
                    paginationDefaultPage={pageactive}
                    customStyles={queueDatatableCustomStyles}
                    noDataComponent={
                      <div className="inv-empty">
                        <div className="inv-empty-icon" aria-hidden="true">📦</div>
                        <p className="inv-empty-title">No active products</p>
                        <p className="inv-empty-sub">Active products will appear here once available.</p>
                      </div>
                    }
                  />
                </div>
              </Paper>
            </Box>
          )}

          {filter == "inactive" && (
            <Box className="products-and-options" sx={{ mt: 1 }}>
              <Paper square className='shadow-none border border-blue-grey-200'>
                <div>
                  <DataTable
                    columns={columns}
                    data={inactivedata}
                    progressPending={loading || defaultLoading}
                    progressComponent={
                      <div style={{ height: "60vh" }}>
                        <Loader />
                      </div>
                    }
                    pagination
                    paginationServer
                    pointerOnHover
                    highlightOnHover
                    paginationTotalRows={totalInActiveRows}
                    paginationPerPage={limitinactive}
                    onChangeRowsPerPage={handlePerRowsInactiveChange}
                    onChangePage={handlePageInactiveChange}
                    paginationRowsPerPageOptions={[10, 50, 100, 150]}
                    currentPage={pageinactive}
                    paginationDefaultPage={pageinactive}
                    customStyles={queueDatatableCustomStyles}
                    noDataComponent={
                      <div className="inv-empty">
                        <div className="inv-empty-icon" aria-hidden="true">📦</div>
                        <p className="inv-empty-title">No inactive products</p>
                        <p className="inv-empty-sub">Inactive products will appear here.</p>
                      </div>
                    }
                  />
                </div>
              </Paper>
            </Box>
          )}

          {/* Bulk Upload Modal */}
          <BulkUploadModal
            show={showBulkModal}
            onHide={handleCloseBulkModal}
            onSuccess={handleBulkUploadSuccess}
            sampleFile={sampleFile}
            sampleImageFile={sampleImageFile}
          />
      </div>
    </>
  );
};

export default Inventory;
